export function isRefreshSessionCurrent(
  currentRefreshToken: string | null | undefined,
  refreshToken: string
) {
  return currentRefreshToken === refreshToken;
}
